import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useAdminUserList } from './hooks';
import { convertToPresentationProps } from './logics';
import { AdminUserListPresentation } from './presentations';

export const AdminUserList: React.FC = () => {
  const {
    state: {
      users,
      currentPage,
      totalPage,
      totalCount,
      enableStaging,
      isOpenCreateModal,
      isOpenEditModal,
      selectedUser,
    },
    actions: {
      handlePageChange,
      handleEdit,
      handleDelete,
      handleCloseEditModal,
      handleOpenCreateModal,
      handleCloseCreateModal,
      handleMutateUsers,
    },
  } = useAdminUserList();

  const { users: convertedUsers } = convertToPresentationProps({ data: users });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: convertedUsers,
    onPageChange: handlePageChange,
  });

  return (
    <AdminUserListPresentation
      users={convertedUsers}
      pagerProps={pagerProps}
      enableStaging={enableStaging}
      isOpenCreateModal={isOpenCreateModal}
      isOpenEditModal={isOpenEditModal}
      selectedUser={selectedUser}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleCloseEditModal={handleCloseEditModal}
      handleOpenCreateModal={handleOpenCreateModal}
      handleCloseCreateModal={handleCloseCreateModal}
      handleMutateUsers={handleMutateUsers}
    />
  );
};
